import Switch from '@rio-cloud/rio-uikit/Switch';
import React from 'react';

interface CustomSwitchProps {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  className?: string;
}

const CustomSwitch: React.FC<CustomSwitchProps> = React.memo(({ label, checked, onChange, className }) => (
  <div className={`display-flex flex-column flex-shrink-0 ${className || ''}`}>
    <label className="margin-bottom-3 text-nowrap">{label}</label>
    <Switch checked={checked} onChange={onChange} enabledText="Sim" disabledText="Não" />
  </div>
));

export default CustomSwitch;
